import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, doc, setDoc, updateDoc, increment, query, orderBy, getDoc } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Visitor {
  date: string; // ISO string 'YYYY-MM-DD'
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class VisitorService {

  constructor(private firestore: Firestore) {}

  /** Track a visitor for today */
  trackVisit(): Observable<void> {
    const today = new Date().toISOString().split('T')[0]; // e.g., '2025-08-13'
    const docRef = doc(this.firestore, `visitors/${today}`);

    // Use getDoc() instead of docRef.get()
    return from(
      getDoc(docRef).then(snapshot => {
        if (snapshot.exists()) {
          return updateDoc(docRef, { count: increment(1) });
        } else {
          return setDoc(docRef, { count: 1 });
        }
      })
    );
  }

  /** Get visitor data, can be daily or monthly */
 getVisitors(period: 'day' | 'month' = 'day'): Observable<{ label: string, count: number }[]> {
    const visitorsRef = collection(this.firestore, 'visitors');

    return collectionData(visitorsRef, { idField: 'date' }).pipe(
      map((data: any[]) => {
        // Sort by date ascending
        data.sort((a, b) => a.date.localeCompare(b.date));

        if (period === 'day') {
          return data.map(item => ({ label: item.date, count: item.count }));
        } else {
          // Aggregate by month
          const monthlyMap = new Map<string, number>();
          data.forEach(item => {
            const month = item.date.substring(0, 7); // 'YYYY-MM'
            monthlyMap.set(month, (monthlyMap.get(month) || 0) + item.count);
          });
          return Array.from(monthlyMap.entries()).map(([label, count]) => ({ label, count }));
        }
      })
    );
  }
}
